import { Id } from "@dgs/core";

export const ALL_CONTACT_PHONE = [
	"privateMobile",
	"workMobile",
	"privateLandline",
	"workLandline",
	"central",
	"other",
] as const;

export type ContactPhoneType = (typeof ALL_CONTACT_PHONE)[number];

export type ContactPhoneIndexResource = {
	id: Id;
	phoneNumber: string;
	type: ContactPhoneType;
	isPrimary: boolean;
};

export type ContactPhoneUpdateResource = ContactPhoneIndexResource;

export type ContactPhoneRequest = Omit<ContactPhoneIndexResource, "id">;

export type ContactPhoneFormState = Omit<ContactPhoneUpdateResource, "id">;
